export const StarIcon = () => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M10.0802 7.89712C11.1568 5.96571 11.6952 5 12.5 5C13.3048 5 13.8432 5.96571 14.9198 7.89712L15.1984 8.3968C15.5043 8.94564 15.6573 9.22007 15.8958 9.40114C16.1343 9.5822 16.4314 9.64942 17.0255 9.78384L17.5664 9.90622C19.6571 10.3793 20.7025 10.6158 20.9512 11.4156C21.1999 12.2153 20.4872 13.0487 19.0619 14.7154L18.6932 15.1466C18.2881 15.6203 18.0856 15.8571 17.9945 16.1501C17.9034 16.443 17.934 16.759 17.9953 17.3909L18.051 17.9662C18.2665 20.19 18.3742 21.3019 17.7231 21.7962C17.072 22.2905 16.0932 21.8398 14.1357 20.9385L13.6292 20.7053C13.073 20.4492 12.7948 20.3211 12.5 20.3211C12.2052 20.3211 11.927 20.4492 11.3708 20.7053L10.8643 20.9385C8.90677 21.8398 7.928 22.2905 7.27688 21.7962C6.62575 21.3019 6.7335 20.19 6.94899 17.9662L7.00474 17.3909C7.06597 16.759 7.09659 16.443 7.00548 16.1501C6.91438 15.8571 6.71186 15.6203 6.30683 15.1466L5.93808 14.7154C4.51276 13.0487 3.8001 12.2153 4.04881 11.4156C4.29751 10.6158 5.34288 10.3793 7.43361 9.90622L7.9745 9.78384C8.56862 9.64942 8.86568 9.5822 9.1042 9.40114C9.34272 9.22007 9.4957 8.94565 9.80165 8.3968L10.0802 7.89712Z"
        fill="#f2b01e"
      ></path>{" "}
    </g>
  </svg>
);
export const ClockIcon = () => (
  <svg
    width="70px"
    height="70px"
    viewBox="0 0 1024 1024"
    class="icon"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M511.3 512.1m-483.5 0a483.5 483.5 0 1 0 967 0 483.5 483.5 0 1 0-967 0Z"
      fill="#89B7F5"
    />
    <path
      d="M511.3 1010.7c-67.3 0-132.6-13.2-194.1-39.2-59.4-25.1-112.7-61.1-158.5-106.8C113 818.9 77.1 765.6 52 706.2c-26-61.5-39.2-126.8-39.2-194.1S26 379.5 52 318.1c25.1-59.4 61.1-112.7 106.8-158.5s99.1-81.7 158.5-106.8c61.5-26 126.8-39.2 194.1-39.2S644 26.8 705.5 52.8c59.4 25.1 112.7 61.1 158.5 106.8 45.8 45.8 81.7 99.1 106.8 158.5 26 61.5 39.2 126.8 39.2 194.1s-13.2 132.6-39.2 194.1C945.7 765.7 909.7 819 864 864.8c-45.8 45.8-99.1 81.7-158.5 106.8-61.6 25.9-126.9 39.1-194.2 39.1z m0-967.1C448.1 43.6 386.7 56 329 80.4c-55.8 23.6-105.9 57.4-149 100.4s-76.8 93.2-100.4 149c-24.4 57.8-36.8 119.1-36.8 182.4s12.4 124.6 36.8 182.4C103.2 750.3 137 800.4 180 843.4c43 43 93.1 76.8 148.9 100.4 57.8 24.4 119.1 36.8 182.4 36.8 63.3 0 124.6-12.4 182.4-36.8 55.8-23.6 105.9-57.4 148.9-100.4 43-43 76.8-93.1 100.4-148.9 24.4-57.8 36.8-119.1 36.8-182.4S967.4 387.5 943 329.7c-23.6-55.8-57.4-105.9-100.4-148.9-43-43-93.1-76.8-148.9-100.4C635.9 56 574.6 43.6 511.3 43.6z"
      fill="#0F53A8"
    />
    <path
      d="M511.3 512.1m-396.3 0a396.3 396.3 0 1 0 792.6 0 396.3 396.3 0 1 0-792.6 0Z"
      fill="#B6CDEF"
    />
    <path
      d="M511.3 923.4c-55.5 0-109.4-10.9-160.1-32.3-49-20.7-93-50.4-130.7-88.1s-67.4-81.8-88.1-130.7C110.9 621.5 100 567.6 100 512.1s10.9-109.4 32.3-160.1c20.7-49 50.4-93 88.1-130.7 37.8-37.8 81.8-67.4 130.7-88.1 50.7-21.5 104.6-32.3 160.1-32.3s109.4 10.9 160.1 32.3c49 20.7 93 50.4 130.7 88.1 37.8 37.8 67.4 81.8 88.1 130.7 21.5 50.7 32.3 104.6 32.3 160.1s-10.9 109.4-32.3 160.1c-20.7 49-50.4 93-88.1 130.7s-81.8 67.4-130.7 88.1c-50.6 21.6-104.4 32.4-160 32.4z m0-792.6c-51.5 0-101.4 10.1-148.4 30-45.4 19.2-86.2 46.7-121.2 81.7s-62.5 75.8-81.7 121.2c-19.9 47-30 96.9-30 148.4s10.1 101.4 30 148.4c19.2 45.4 46.7 86.2 81.7 121.2s75.8 62.5 121.2 81.7c47 19.9 96.9 30 148.4 30s101.4-10.1 148.4-30c45.4-19.2 86.2-46.7 121.2-81.7s62.5-75.8 81.7-121.2c19.9-47 30-96.9 30-148.4s-10.1-101.4-30-148.4c-19.2-45.4-46.7-86.2-81.7-121.2s-75.8-62.5-121.2-81.7c-47-19.9-96.9-30-148.4-30z"
      fill="#0F53A8"
    />
    <path
      d="M511.3 246.7c-8.3 0-15-6.7-15-15v-47.2c0-8.3 6.7-15 15-15s15 6.7 15 15v47.2c0 8.3-6.7 15-15 15zM511.3 854.7c-8.3 0-15-6.7-15-15v-47.2c0-8.3 6.7-15 15-15s15 6.7 15 15v47.2c0 8.3-6.7 15-15 15zM709.6 328.8c-3.8 0-7.7-1.5-10.6-4.4-5.9-5.9-5.9-15.4 0-21.2l33.4-33.4c5.9-5.9 15.4-5.9 21.2 0 5.9 5.9 5.9 15.4 0 21.2l-33.4 33.4c-2.9 3-6.7 4.4-10.6 4.4zM279.7 758.8c-3.8 0-7.7-1.5-10.6-4.4-5.9-5.9-5.9-15.4 0-21.2l33.4-33.4c5.9-5.9 15.4-5.9 21.2 0 5.9 5.9 5.9 15.4 0 21.2l-33.4 33.4c-2.9 2.9-6.8 4.4-10.6 4.4zM838.9 527.1h-47.2c-8.3 0-15-6.7-15-15s6.7-15 15-15h47.2c8.3 0 15 6.7 15 15s-6.7 15-15 15zM230.9 527.1h-47.2c-8.3 0-15-6.7-15-15s6.7-15 15-15h47.2c8.3 0 15 6.7 15 15s-6.7 15-15 15z"
      fill="#0F53A8"
    />
    <path
      d="M743 758.8c-3.8 0-7.7-1.5-10.6-4.4L699 721c-5.9-5.9-5.9-15.4 0-21.2 5.9-5.9 15.4-5.9 21.2 0l33.4 33.4c5.9 5.9 5.9 15.4 0 21.2-2.9 2.9-6.8 4.4-10.6 4.4zM313 328.8c-3.8 0-7.7-1.5-10.6-4.4L269 291c-5.9-5.9-5.9-15.4 0-21.2 5.9-5.9 15.4-5.9 21.2 0l33.4 33.4c5.9 5.9 5.9 15.4 0 21.2-2.9 3-6.7 4.4-10.6 4.4z"
      fill="#0F53A8"
    />
    <path d="M493 512.1l18.3-239.4 18.4 239.4z" fill="#B6CDEF" />
    <path
      d="M529.7 527.1H493c-4.2 0-8.2-1.7-11-4.8s-4.3-7.2-4-11.3l18.3-239.5c0.6-7.8 7.1-13.9 15-13.9 7.8 0 14.4 6 15 13.9L544.6 511c0.3 4.2-1.1 8.3-4 11.3s-6.8 4.8-10.9 4.8z m-20.5-30h4.3l-2.1-27.9-2.2 27.9z"
      fill="#0F53A8"
    />
    <path d="M517.5 499.7l138.9 162-162-138.9z" fill="#B6CDEF" />
    <path
      d="M656.4 676.7c-3.5 0-6.9-1.2-9.8-3.6l-162-138.9c-3.2-2.7-5.1-6.6-5.2-10.8-0.2-4.2 1.4-8.2 4.4-11.2l23-23c3-3 7-4.5 11.2-4.4 4.2 0.2 8.1 2.1 10.8 5.2l138.9 162c5.1 6 4.8 14.8-0.8 20.4-2.8 2.8-6.6 4.3-10.5 4.3zM516.5 521.9l0.9 0.8-0.8-0.9-0.1 0.1z"
      fill="#0F53A8"
    />
    <path d="M242 616.5l266-104.4" fill="#B6CDEF" />
    <path
      d="M242 631.5c-6 0-11.6-3.6-14-9.5-3-7.7 0.8-16.4 8.5-19.4l266-104.3c7.7-3 16.4 0.8 19.4 8.5s-0.8 16.4-8.5 19.4l-266 104.3c-1.7 0.6-3.6 1-5.4 1z"
      fill="#0F53A8"
    />
    <path
      d="M511.3 512.1m-30.1 0a30.1 30.1 0 1 0 60.2 0 30.1 30.1 0 1 0-60.2 0Z"
      fill="#B6CDEF"
    />
    <path
      d="M511.3 557.3c-24.9 0-45.1-20.2-45.1-45.1 0-24.9 20.2-45.1 45.1-45.1s45.1 20.2 45.1 45.1c0.1 24.8-20.2 45.1-45.1 45.1z m0-60.3c-8.3 0-15.1 6.8-15.1 15.1s6.8 15.1 15.1 15.1 15.1-6.8 15.1-15.1c0.1-8.3-6.7-15.1-15.1-15.1z"
      fill="#0F53A8"
    />
  </svg>
);
export const IndustryIcon = () => (
  <svg width="70px" height="70px" viewBox="0 0 32.046 32.045">
    <g>
      <g>
        <path
          d="M18.812,12.025l-0.55,1.798c0.491,0.157,0.85,0.639,0.85,1.21c0,0.286-0.091,0.549-0.242,0.761l1.433,1.17
			c0.396-0.533,0.63-1.203,0.63-1.932C20.932,13.606,20.033,12.41,18.812,12.025z"
        />
        <path
          d="M17.622,16.374c-0.652-0.006-1.179-0.572-1.179-1.262c0-0.689,0.526-1.255,1.179-1.26c0.123-0.001,0.24,0.018,0.353,0.054
			l0.547-1.795c-0.285-0.09-0.587-0.136-0.898-0.129c-1.61,0.033-2.895,1.436-2.895,3.129c0,1.694,1.284,3.099,2.895,3.132
			c0.963,0.021,1.828-0.451,2.383-1.202l-1.427-1.169C18.358,16.179,18.013,16.377,17.622,16.374z"
        />
        <path
          d="M30.155,12.956c1.891-0.733,1.891-0.804,1.891-0.994v-1.482c0-0.19,0-0.27-1.892-0.944l-0.066-0.024l-0.267-0.633
			l0.028-0.064c0.805-1.823,0.749-1.877,0.615-2.009l-1.07-1.047c-0.044-0.043-0.121-0.074-0.188-0.074
			c-0.062,0-0.242,0-1.826,0.717L27.317,6.43l-0.651-0.263L26.64,6.102c-0.745-1.844-0.823-1.844-1.007-1.844h-1.514
			c-0.187,0-0.27,0-0.959,1.847l-0.026,0.067l-0.649,0.265l-0.062-0.026c-1.071-0.452-1.696-0.681-1.859-0.681
			c-0.065,0-0.144,0.03-0.188,0.073l-1.073,1.049c-0.136,0.134-0.192,0.19,0.653,1.975l0.03,0.066L19.72,9.525L19.654,9.55
			c-0.215,0.083-0.401,0.157-0.57,0.224c-0.063,0.025-0.438,0.269-0.673,0.417l-4.931-0.27l-1.696,8.13h-0.001l-0.033,0.005
			c-0.41-0.696-1.174-1.092-2.239-1.092H9.045c-0.625,0.61-1.718,1.019-2.97,1.019s-2.345-0.408-2.97-1.019H2.639
			c-1.643,0-2.584,0.928-2.584,2.476c0,1.549-0.05,5.781-0.05,6.625s-0.101,1.723,0.627,1.723c0.269,0,1.125,0,2.235,0
			c1.059,0,2.076,0,3.009,0c0.129,0,0.272,0,0.397,0c1.196,0,2.19,0,2.762,0c0.102,0,0.173,0,0.247,0c0.032,0,0.08,0,0.106,0
			c0.93,0,1.644,0,1.882,0c0.099,0,0.192,0,0.247,0c0.729,0,0.627-0.879,0.627-1.723c0-0.13-0.002-0.349-0.003-0.617h19.881v-1.345
			H12.13c-0.004-0.379-0.008-0.784-0.012-1.196l1.895,0.725l9.375-1.491l0.939-3.896h1.367c0.19,0,0.27,0,0.959-1.848l0.026-0.066
			l0.65-0.263l0.062,0.025c1.07,0.453,1.695,0.682,1.857,0.682c0.064,0,0.145-0.029,0.188-0.072l1.073-1.051
			c0.136-0.135,0.191-0.19-0.655-1.973l-0.03-0.067l0.265-0.63L30.155,12.956z M13.951,10.681l9.806,0.655l-2.146,9.061l-9.188-2.6
			L13.951,10.681z M12.095,19.44c0-0.277-0.04-0.527-0.1-0.764l0.035-0.006l7.777,2.221l-3.552,0.503l-4.159-1.354
			C12.096,19.815,12.095,19.61,12.095,19.44z M12.1,20.589l1.073,0.358l-1.069,0.16C12.102,20.929,12.101,20.755,12.1,20.589z
			 M25.451,13.591l0.565-2.347l-0.568-0.396L22.91,21.676l-8.834,1.292v-0.004l-1.963-0.718c-0.002-0.188-0.004-0.371-0.005-0.555
			l1.999,0.717l8.259-1.108l2.547-10.756l-2.273-0.123c0.027-0.101,0.056-0.201,0.063-0.216c0.396-0.802,1.234-1.357,2.204-1.357
			c1.353,0,2.451,1.078,2.451,2.404C27.358,12.393,26.542,13.348,25.451,13.591z"
        />
        <path
          d="M1.618,11.909c-0.009,0.058-0.021,0.116-0.028,0.175c-0.273,2.544,1.526,4.833,4.012,5.102
			c2.487,0.27,4.734-1.583,5.01-4.127c0.041-0.393,0.029-0.778-0.023-1.152c0.292-0.002,0.473-0.006,0.513-0.012
			c0.317-0.04,0.57-0.063,0.596-0.413c0.005-0.467-0.008-0.392-0.001-0.461c0.008-0.404-0.229-0.357-0.491-0.385
			c-0.262-0.028-0.583,0.012-0.583,0.012S9.868,5.572,5.172,6.401C3.768,6.649,2.843,7.242,2.235,7.95
			c1.199-0.596,2.613-0.882,3.843-0.713c1.173,0.162,2.093,0.706,2.686,1.571C8.369,8.515,7.926,8.285,7.442,8.135
			C6.959,7.85,6.446,7.712,6.019,7.653C4.601,7.451,2.93,7.899,1.693,8.749C0.9,10.26,1.13,11.907,1.13,11.907
			S1.313,11.907,1.618,11.909z M2.425,12.174c0.009-0.089,0.025-0.176,0.042-0.263c1.897,0.003,5.361,0.009,7.275,0.001
			c0.059,0.341,0.074,0.695,0.034,1.056c-0.226,2.084-2.059,3.603-4.084,3.383C3.664,16.132,2.2,14.258,2.425,12.174z"
        />
      </g>
    </g>
  </svg>
);
export const SkillIcon = () => (
  <svg height="70" width="70" viewBox="0 0 460 460">
    <path
      style={{ fill: "#59595A" }}
      d="M370.898,143.68c-0.204-0.108-0.413-0.212-0.617-0.32c0.009-0.231,0.023-0.464,0.031-0.694
        c1.709-48.474-13.321-84.39-42.321-101.133c-29.001-16.744-67.62-11.802-108.745,13.916c-0.196,0.122-0.39,0.251-0.586,0.375
        c-0.195-0.123-0.39-0.252-0.586-0.375C176.949,29.732,138.33,24.79,109.329,41.533c-29,16.743-44.03,52.66-42.321,101.133
        c0.008,0.23,0.023,0.464,0.031,0.694c-0.204,0.108-0.413,0.212-0.617,0.32C23.59,166.437,0,197.411,0,230.898
        s23.59,64.461,66.424,87.218c0.204,0.108,0.413,0.212,0.617,0.32c-0.009,0.231-0.023,0.464-0.031,0.694
        c-1.709,48.474,13.321,84.391,42.321,101.134c11.29,6.518,24.031,9.75,37.816,9.749c21.626-0.001,45.813-7.958,70.929-23.665
        c0.196-0.122,0.39-0.251,0.586-0.375c0.195,0.123,0.39,0.252,0.586,0.375c25.118,15.708,49.3,23.665,70.928,23.665
        c13.783,0,26.529-3.232,37.816-9.749c29-16.743,44.031-52.66,42.321-101.134c-0.008-0.23-0.023-0.464-0.031-0.694
        c0.204-0.108,0.413-0.212,0.617-0.32c42.834-22.756,66.424-53.731,66.424-87.218S413.732,166.437,370.898,143.68z M306.005,281.326
        c-9.593,16.616-20.186,32.157-31.485,46.323c-17.917,2.702-36.673,4.105-55.859,4.105s-37.942-1.403-55.859-4.105
        c-11.299-14.166-21.892-29.707-31.485-46.323s-17.756-33.561-24.374-50.428c6.619-16.868,14.781-33.812,24.374-50.428
        s20.187-32.157,31.485-46.323c17.917-2.702,36.672-4.105,55.859-4.105s37.942,1.404,55.859,4.105
        c11.299,14.166,21.892,29.707,31.485,46.323s17.755,33.56,24.374,50.428C323.761,247.766,315.599,264.71,306.005,281.326z
        M340.033,259.148c4.692,16.156,7.854,32.022,9.37,47.233c-13.931,6.292-29.253,11.488-45.59,15.502
        c6.856-9.736,13.385-19.943,19.513-30.558S335.029,269.954,340.033,259.148z M218.661,381.865
        c-12.415-8.918-24.575-19.59-36.22-31.731c11.859,1.07,23.964,1.62,36.22,1.62s24.361-0.55,36.22-1.62
        C243.236,362.275,231.076,372.947,218.661,381.865z M133.51,321.884c-16.337-4.015-31.659-9.209-45.59-15.502
        c1.516-15.211,4.678-31.078,9.37-47.233c5.003,10.806,10.579,21.564,16.707,32.178C120.125,301.94,126.654,312.148,133.51,321.884z
        M113.997,170.47c-6.128,10.614-11.704,21.372-16.707,32.178c-4.692-16.156-7.854-32.023-9.37-47.233
        c13.931-6.292,29.253-11.487,45.59-15.502C126.654,149.648,120.125,159.856,113.997,170.47z M218.661,79.931
        c12.415,8.918,24.575,19.59,36.22,31.731c-11.86-1.07-23.964-1.62-36.22-1.62s-24.36,0.55-36.22,1.62
        C194.087,99.521,206.247,88.85,218.661,79.931z M323.326,170.47c-6.128-10.614-12.657-20.822-19.513-30.558
        c16.337,4.015,31.659,9.209,45.59,15.502c-1.516,15.211-4.678,31.078-9.37,47.233C335.029,191.842,329.454,181.084,323.326,170.47z
        M290.073,51.786c10.331,0,19.734,2.341,27.918,7.067c20.821,12.021,32.21,38.575,32.447,75.224
        c-19.76-8.177-41.788-14.386-65.229-18.444c-15.232-18.268-31.62-34.238-48.578-47.261C255.961,57.38,274.127,51.786,290.073,51.786
        z M119.331,58.853c8.186-4.726,17.585-7.067,27.918-7.067c15.946,0,34.114,5.595,53.442,16.586
        c-16.958,13.023-33.347,28.993-48.578,47.261c-23.44,4.058-45.469,10.267-65.229,18.444C87.122,97.428,98.51,70.874,119.331,58.853z
        M20,230.898c0-24.042,17.303-47.182,48.922-65.711c2.799,21.201,8.436,43.383,16.642,65.711
        c-8.206,22.329-13.843,44.51-16.642,65.711C37.303,278.08,20,254.94,20,230.898z"
    />
  </svg>
);

export const MapIcon = () => (
  <svg
    version="1.1"
    id="_x32_"
    width="15px"
    height="15px"
    viewBox="0 0 512 512"
  >
    <g>
      <path
        style={{ fill: "#fff" }}
        className="st0"
        d="M256,0C159.969,0,82.109,77.859,82.109,173.906c0,100.719,80.016,163.688,123.297,238.719
		C246.813,484.406,246.781,512,256,512s9.188-27.594,50.594-99.375c43.297-75.031,123.297-138,123.297-238.719
		C429.891,77.859,352.031,0,256,0z M256,240.406c-36.734,0-66.516-29.781-66.516-66.5c0-36.75,29.781-66.531,66.516-66.531
		s66.516,29.781,66.516,66.531C322.516,210.625,292.734,240.406,256,240.406z"
      />
    </g>
  </svg>
);
export const PhoneIcon = () => (
  <svg
    width="17px"
    height="17px"
    viewBox="0 0 24 24"
    fill="#fff"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5562 12.9062L16.1007 13.359C16.1007 13.359 15.0181 14.4355 12.0631 11.4972C9.10812 8.55901 10.1907 7.48257 10.1907 7.48257L10.4775 7.19738C11.1841 6.49484 11.2507 5.36691 10.6342 4.54348L9.37326 2.85908C8.61028 1.83992 7.13596 1.70529 6.26145 2.57483L4.69185 4.13552C4.25823 4.56668 3.96765 5.12559 4.00289 5.74561C4.09304 7.33182 4.81071 10.7447 8.81536 14.7266C13.0621 18.9492 17.0468 19.117 18.6763 18.9651C19.1917 18.9171 19.6399 18.6546 20.0011 18.2954L21.4217 16.883C22.3806 15.9295 22.1102 14.2949 20.8833 13.628L18.9728 12.5894C18.1672 12.1515 17.1858 12.2801 16.5562 12.9062Z"
      fill="#fff"
    />
  </svg>
);
export const MailIcon = () => (
  <svg
    width="17px"
    height="17px"
    viewBox="0 0 24 24"
    fill="#fff"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 4.25H5C4.53668 4.25263 4.09309 4.43784 3.76546 4.76546C3.43784 5.09309 3.25263 5.53668 3.25 6V18C3.25263 18.4633 3.43784 18.9069 3.76546 19.2345C4.09309 19.5622 4.53668 19.7474 5 19.75H19C19.4633 19.7474 19.9069 19.5622 20.2345 19.2345C20.5622 18.9069 20.7474 18.4633 20.75 18V6C20.7474 5.53668 20.5622 5.09309 20.2345 4.76546C19.9069 4.43784 19.4633 4.25263 19 4.25ZM5 5.75H19C19.0663 5.75 19.1299 5.77634 19.1768 5.82322C19.2237 5.87011 19.25 5.9337 19.25 6V7.54L12 11.16L4.75 7.54V6C4.75 5.9337 4.77634 5.87011 4.82322 5.82322C4.87011 5.77634 4.9337 5.75 5 5.75ZM19 18.25H5C4.9337 18.25 4.87011 18.2237 4.82322 18.1768C4.77634 18.1299 4.75 18.0663 4.75 18V9.21L11.66 12.67C11.7656 12.7228 11.882 12.7503 12 12.7503C12.118 12.7503 12.2344 12.7228 12.34 12.67L19.25 9.21V18C19.25 18.0663 19.2237 18.1299 19.1768 18.1768C19.1299 18.2237 19.0663 18.25 19 18.25Z"
      fill="#fff"
    />
  </svg>
);

export const ScrollTopIcon = ({ scrollProgress, color }) => (
  <svg className="absolute w-12 h-12 md:w-16 md:h-16" viewBox="0 0 36 36">
    <path
      className="text-gray-300"
      strokeDasharray="100, 100"
      d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <path
      className={color}
      strokeDasharray={`${scrollProgress}, 100`}
      d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
  </svg>
);

export const ArrowIcon = ({ color = '#000000' }) => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 4V20M12 4L8 8M12 4L16 8"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BarIcon = () => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="fff"
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4 6H20M4 12H20M4 18H20"
    />
  </svg>
);
export const CrossIcon = () => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 5L4.99998 19M5.00001 5L19 19"
      stroke="#fff"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ArrowleftIcon = () => (
  <svg
    fill="#fffff"
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    id="right-arrow"
    data-name="Flat Color"
    xmlns="http://www.w3.org/2000/svg"
    class="icon flat-color"
  >
    <path
      id="primary"
      d="M21.71,11.29l-3-3a1,1,0,0,0-1.42,1.42L18.59,11H3a1,1,0,0,0,0,2H18.59l-1.3,1.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l3-3A1,1,0,0,0,21.71,11.29Z"
    ></path>
  </svg>
);
export const LinkedInIcon =()=>{
  <svg width="10px" height="10px" viewBox="0 -2 44 44" version="1.1"     fill="#fffff"
>
    


    <g id="Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        
            <path d="M746,305 L736.2754,305 L736.2754,290.9384 C736.2754,287.257796 734.754233,284.74515 731.409219,284.74515 C728.850659,284.74515 727.427799,286.440738 726.765522,288.074854 C726.517168,288.661395 726.555974,289.478453 726.555974,290.295511 L726.555974,305 L716.921919,305 C716.921919,305 717.046096,280.091247 716.921919,277.827047 L726.555974,277.827047 L726.555974,282.091631 C727.125118,280.226996 730.203669,277.565794 735.116416,277.565794 C741.21143,277.565794 746,281.474355 746,289.890824 L746,305 L746,305 Z M707.17921,274.428187 L707.117121,274.428187 C704.0127,274.428187 702,272.350964 702,269.717936 C702,267.033681 704.072201,265 707.238711,265 C710.402634,265 712.348071,267.028559 712.41016,269.710252 C712.41016,272.34328 710.402634,274.428187 707.17921,274.428187 L707.17921,274.428187 L707.17921,274.428187 Z M703.109831,277.827047 L711.685795,277.827047 L711.685795,305 L703.109831,305 L703.109831,277.827047 L703.109831,277.827047 Z" id="LinkedIn">


              
</path>
      
    </g>
</svg>
}
export const IdeationIcon = ({ color }) => (
  <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" fill={color} />
  </svg>
);
export const UIDesignIcon = ({ color }) => (
  <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
    <path d="M3 4H21V20H3V4ZM5 6V18H19V6H5ZM15 10H9V12H15V10ZM15 14H9V16H15V14Z" fill={color} />
  </svg>
);
export const BackendIcon = ({ color }) => (
  <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
    <path d="M3 4H21V20H3V4ZM5 6V18H19V6H5ZM11 10H13V12H11V10ZM11 14H13V16H11V14Z" fill={color} />
  </svg>
);
export const FrontendIcon = ({ color }) => (
  <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C8.69 20 6 17.31 6 14H8C8 16.21 9.79 18 12 18C14.21 18 16 16.21 16 14H18C18 17.31 15.31 20 12 20ZM12 16C9.79 16 8 14.21 8 12H10C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12H16C16 14.21 14.21 16 12 16ZM12 4C8.69 4 6 6.69 6 10C6 11.71 6.69 13.29 7.9 14.59C8.45 15.15 9.19 15.5 10 15.5C10.81 15.5 11.55 15.15 12.1 14.59C13.29 13.29 14 11.71 14 10C14 6.69 11.31 4 12 4Z" fill={color} />
  </svg>
);
export const DeploymentIcon = ({ color }) => (
  <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
    <path d="M3 3C3 2.45 3.45 2 4 2H20C20.55 2 21 2.45 21 3V21C21 21.55 20.55 22 20 22H4C3.45 22 3 21.55 3 21V3ZM4 0C2.34 0 1 1.34 1 3V21C1 22.66 2.34 24 4 24H20C21.66 24 23 22.66 23 21V3C23 1.34 21.66 0 20 0H4ZM10 17H14V19H10V17ZM10 15H14V13H10V15ZM10 11H14V9H10V11ZM10 7H14V5H10V7Z" fill={color} />
  </svg>
);
export const MaintenanceIcon = ({ color }) => (
  <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
    <path d="M3 3C3 2.45 3.45 2 4 2H20C20.55 2 21 2.45 21 3V21C21 21.55 20.55 22 20 22H4C3.45 22 3 21.55 3 21V3ZM4 0C2.34 0 1 1.34 1 3V21C1 22.66 2.34 24 4 24H20C21.66 24 23 22.66 23 21V3C23 1.34 21.66 0 20 0H4ZM10 17H14V19H10V17ZM10 15H14V13H10V15ZM10 11H14V9H10V11ZM10 7H14V5H10V7Z" fill={color} />
  </svg>
);
